import { Refresh } from '@browser/Browser';
import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { ICommandBase } from '@Quest/cqrs';
import { UpdateStrategySettingsCommandV1 } from '@Quest/Strategies/Domain/commands-core';
import StrategiesCommands from '@Quest/Strategies/Domain/commands-vue-component';
import StrategiesQueries from '@Quest/Strategies/Domain/queries-vue-component';
import { StrategySettingsReadModel } from '@Quest/Strategies/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';


@Component({ components: { CorporateNavigation } })
export default class StrategySettingsPage extends mixins(StrategiesCommands, StrategiesQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: StrategySettingsReadModel | null = null;
    currencies: string[] = ['AUD', 'BRL', 'CAD', 'EUR', 'GBP', 'JPY', 'USD'];

    handleDeleteStrategyCommand()
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeleteStrategyCommandV1(this.workspaceId, this.strategyId);
        }
    }

    handleUpdateStrategySettingsCommand()
    {
        if (this.rm)
        {
            this.invokeUpdateStrategySettingsCommandV1(this.workspaceId, this.strategyId, this.rm.Name, this.rm.Description, this.rm.Currency, this.rm.DefaultPnlId, 
                this.rm.IncludeCogs, this.rm.IncludeOpex, this.rm.IncludeOther, this.rm.FiscalYearStartMonth);
        }
    }

    mounted()
    {
        document.title = "Settings | TransparentChoice";
        this.runStrategySettingsQueryV1(this.workspaceId, this.strategyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "StrategySettingsReadModel")
        {
            this.rm = model as StrategySettingsReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdateStrategySettingsCommandV1.matchType(cmd))
        {
            Refresh();
        }
    }
}